import React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { useRestaurant } from 'query/hooks';

import messages from 'messages';
import Language from '../containers/layout/language';

function Home({ ...props }) {
    const restaurant = useRestaurant()?.data || {};

    const btnClasses = () => {
        const classes = ['btn outline'];

        if (['barr', 'geist'].indexOf(restaurant.domain) !== -1) {
            classes.push('black');
        } else {
            classes.push('white');
        }

        return classes.join(' ');
    };

    const { formatMessage } = props.intl;

    return (
        <div className="page-wrapper page-home">
            <Language />
            <div
                className="banner"
                style={{ backgroundImage: `url(${restaurant.backgroundImageUrl})` }}
            >
                <div className="content">
                    {restaurant.logoUrl ? (
                        <div className="logo">
                            <img src={restaurant.logoUrl} alt={restaurant.name} />
                        </div>
                    ) : (
                        <div className="restaurant-name">
                            <h5 data-test="restaurant-name">{restaurant.name}</h5>
                        </div>
                    )}
                    <div className="btn-container">
                        <Link
                            className={btnClasses()}
                            to={`/${restaurant.domain}/choose`}
                            data-test="home-button"
                        >
                            <span data-test="buy-gift-card-button" className="flex">
                                {formatMessage(messages.homeButton)}
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default injectIntl(React.memo(Home));
